import { mapActions } from 'vuex';

// eslint-disable-next-line
export const installationMixin = {
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      collectionPoint: {},
      collectionPointLoading: false,
      eanErrorMessage: null,
    };
  },
  methods: {
    ...mapActions({
      getInstallation: 'installations/getInstallation',
    }),
    loadInstallation(params) {
      return new Promise((resolve, reject) => {
        this.collectionPointLoading = true;
        if (!this.$route.params.data) {
          const requestParams = {
            ean: this.$route.params.ean,
            checkAgreementExistence: params?.checkAgreementExistence,
          };
          this.getInstallation(requestParams).then((response) => {
            resolve(response);
            if (response.status === 200) {
              this.collectionPoint = response.data;
            }
          }).catch((error) => {
            reject(error);
            if (error.response && error.response.status === 404) {
              this.$router.push({
                name: 'collectionPoint',
                params: {
                  ean: this.$route.params.ean,
                  eanErrorMessage: 'Zadaný EAN nebyl nalezen',
                },
              });
            }
          }).finally(() => {
            this.collectionPointLoading = false;
          });
        } else {
          this.collectionPoint = this.$route.params.data;
          this.collectionPointLoading = false;
          resolve(this.$route.params);
        }
      });
    },
    searchInstallation(searchedEan) {
      this.eanErrorMessage = null;
      this.collectionPointLoading = true;
      const params = {
        ean: searchedEan,
      };
      const prefix = this.$route.name.split('.')[0];
      if (prefix === 'requestVN' || prefix === 'requestNN') {
        params.checkAgreementExistence = true;
      }
      this.getInstallation(params).then((response) => {
        if (response.status === 200) {
          this.collectionPoint = response.data;
          if (response.data.activeAgreementRequest === true) {
            this.errorMessage = 'Pro zadaný EAN již evidujeme aktivní žádost.';
          }
          if (response.data.allowedInstallationAction.name === 'NONE_MANUFACTURING_INSTALLATION'
            || response.data.allowedInstallationAction.name === 'NONE_DISTRIBUTION_ONLY_INSTALLATION') {
            this.$router.push({
              name: 'collectionPoint',
              params: {
                ean: searchedEan,
                eanErrorMessage: response.data.allowedInstallationAction.localizedText,
              },
            });
          } else if (this.$route.params.ean !== searchedEan) {
            this.$router.push({
              name: this.$route.name,
              params: {
                ean: response.data.ean,
                data: response.data,
              },
            });
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          this.eanErrorMessage = 'Zadaný EAN nebyl nalezen';
          this.$router.push({
            name: 'collectionPoint',
            params: {
              ean: searchedEan,
              eanErrorMessage: this.eanErrorMessage,
            },
          });
        }
      }).finally(() => {
        this.collectionPointLoading = false;
      });
    },
    redirectByVoltageLevel(data, unavailableVoltageLevel) {
      if (data && data.voltageLevel === unavailableVoltageLevel) {
        this.$router.push({
          name: 'collectionPoint.detail',
          params: {
            ean: this.$route.params.ean,
          },
        });
      }
    },
  },
};
